import {Component} from '../../core';
import constants from '../../cityConstant.js';
import {isSet,seoUrl,isEmpty} from '../../utils/common';

/**
 * Coworkhome Popular partners component
 */
export class CoworkPopularPartnersComponent extends Component {

    static alias = 'cowork-home-popular-partners';

    constructor(el) {
        super(el);
    }

    onComponentLoaded() {

        // Initialize the popular spaces
        this.initializePopularPartners();
    }

    initializePopularPartners(){
        let cityId = '';
        if(globals.cityId != 1) {
            cityId = globals.cityId;
        }
        this.fetchPopularPartners(cityId, 4).then((popularPartners) => {
            // Update the state
            this.setState({...this.state, popularPartners});
            
            // Render popular spaces
            this.renderPopularPartners(this.state.popularPartners);
        });
    }

    fetchPopularPartners(cityId, size) {
        // Render popular spaces
        return fetch(`/homes/re2/coworkPopularPartners?cityId=${cityId}&size=${size}`).then((res) => res.json());
    }

    /**
     * Renders popular spaces
     * @param {Array} popular spaces 
     */
    renderPopularPartners(popularPartners = []) {

        this.refs.popularPartners.innerHTML = popularPartners.reduce((html, response) => html + `
           <a onclick="coworkGa('QH_CoWork','Homepage_CoWork_Center-tile', 'QH_CoWork_Homepage_Center-tile_most-popular-partners_Click');" href="${this.getHrefLinks(response)}" class="cw_mpp_tile">
                <div class="cw_mpp_img_wrapper">
                ${this.getImageUrl(response)}
                </div>
                <h3>${response.name}</h3>
                <div class="cw_mpp_star">
                ${this.getRating(response.rating)}
                </div>
                <div class="content_box">${(response.description.length >= 80) ? response.description.substr(0, 80) : response.description} <span> Read More</span></div>
                <div href="" class="cw_dp_link">Details &amp; Price <svg class="icon-right-arrow" width="14px" height="14px"><use xlink:href="#icon-right-arrow"></use></svg></div>
            </a>`, '');

        if(isEmpty(this.refs.popularPartners.innerHTML)){
            document.getElementById("popularPartnersSection").classList.add('hide');
        }

    }

    getHrefLinks(response) {
        if(response.name == '91 Spring Board') {
            return "https://www.quikr.com/cars-bikes/partnerships/91springboard";
        } else {
            return `//www.quikr.com/coworking/coworking-spaces?q=${this.getPartnersQuery(response.name, response.id)}` 
        }
    }

    getImageUrl(response) {
        if(response.media && response.media != '' && response.media != 'NULL') {
            let image = response.media.replace("80x80","300x300");
            return `<img src="${image}" />`;
        } else {
            return `<img class="defualt_img" src="${window.CDNURL}/image/QC_DefaultImage.jpg" />`
        }
    }

    getRating(rating){
        var stars = '';
        for (var i=1; i<=5; i=i+1) {
            if(rating>1){
            stars += '<i class="icon icon-star_filled"></i>';
            rating--;
            }else if(rating >= 0.5){
            stars += '<i class="icon icon-star_filled"></i>';
            rating--;
            }else if(rating> 0 && rating< 0.5){
            stars += '<i class="icon icon-star_half"></i>';
            rating--;
            }else{
                stars += '<i class="icon icon-star_empty"></i>';
            rating--;
            }
        }
        return stars;
    }

    getPartnersQuery(partnername, id)
    {
        let query = '';
        if(partnername != '' && partnername != 'undefined') {
            let filter = {
                'partners' : {}
            };
            filter.partners.name = partnername.toLowerCase().replace("_"," ").replace(/\b\w/g, l => l.toUpperCase());
            filter.partners.id = id;
            query = JSON.stringify(filter);
            query = btoa(query);
            query = encodeURIComponent(query);
        }
        return query;
    }


}